// Register all custom Turbo Stream actions
import { redirect, update_url } from "./navigation"
import { openModal, closeModal } from "../controllers/crud/modal_controller"
import { setTabStates } from "../controllers/crud/tabs_controller"

export function registerTurboStreamActions() {
  Turbo.StreamActions.redirect = redirect
  Turbo.StreamActions.update_url = update_url
  Turbo.StreamActions.open_modal = openModal
  Turbo.StreamActions.close_modal = closeModal
  Turbo.StreamActions.set_tab_states = setTabStates
}
